import Vue from 'vue'
import Vuex from 'vuex'
import utils from '../modules/utils'
import proyectos from '../modules/proyectos'
import Fodes from "./empresas/index"

Vue.use(Vuex)

const URL = process.env.VUE_APP_API_URL
export default new Vuex.Store({
    state: {
        token: null,
        userInfo: {},
        perfil_usuario: {
            es_empleado:true
        },
        counterReview: {
            countProjectRequestCreatedByMayorPendingReview: 0,
            countProjectByMayorPendingReview: 0,
            countProjectRequestPendingApproval: 0,
            countProcessPendingApproval: 0,
        },
        URL: URL,
    },
    mutations: {
        setToken(state, payload) {
            state.token = payload
        },
        setUserInfo(state, payload) {
            state.userInfo = payload
        },
        setPerfilUsuario(state, payload) {
            state.perfil_usuario = payload
        },
        setCounterReview(state, payload) {
            if (payload.index === 1) state.counterReview.countProjectRequestCreatedByMayorPendingReview = payload.count
            if (payload.index === 2) state.counterReview.countProjectByMayorPendingReview = payload.count
            if (payload.index === 3) state.counterReview.countProjectRequestPendingApproval = payload.count
            if (payload.index === 4) state.counterReview.countProcessPendingApproval = payload.count
        }
    },
    actions: {
        setToken({commit}, payload) {
            commit('setToken', payload)
        },
        setUserInfo({commit}, payload) {
            commit('setUserInfo', payload)
        },
        setPerfilUsuario({commit}, payload) {
            commit('setPerfilUsuario', payload)
        },
        setCounterReview({commit}, payload) {
            commit('setCounterReview', payload)
        },
    },
    getters: {
        getURL: (state) => {
            return state.URL
        },
        getToken: (state) => {
            return state.token
        },
        getUserInfo: (state) => {
            return state.userInfo
        },
        getPerfilUsuario: (state) => {
            return state.perfil_usuario
        },
        getCounterReview: (state) => {
            return state.counterReview
        }
    },
    modules: {
        utils,
        Fodes,
        proyectos
    }
})
